import { Card } from "primereact/card"
import { ReactComponent as EletropostoIcon } from '../images/eletroposto.svg';
import eletropostoPic from '../images/eletroposto.png';
type Props = {
  title: React.ComponentType
  children: React.ReactNode
  // body: React.ComponentType
  footer: React.ComponentType
}
const header = (
  <div style={{ backgroundImage: `url(${eletropostoPic})`, backgroundSize: `512px 250px`, width: '512px', height: '250px', display: 'flex', alignItems: 'center' }}>
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', width: '100%', backgroundColor: 'rgba(127, 127, 127, 0.5)', height: '70px' }}>
      <EletropostoIcon width={50} height={50} color='white' />
      <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', marginLeft: 5 }}>
        <div style={{ color: 'white', fontWeight: 'bold', fontSize: '30px' }}>ELETROPOSTO UFMS</div>
        <div style={{ color: 'white', fontSize: '12px', marginTop: -5 }}>Departamento de Engenharia Elétrica e BATLAB</div>
      </div>
    </div>
  </div>
)

const Panel = ({ title: TitleComponent, footer: FooterComponent, children }: Props) => {
  return (
    <div style={{ border: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#999999' }}>
      <Card
        header={header}
        title={<TitleComponent />}
        // subTitle={`Olá ${authenticator.profile?.nome?.split(' ')[0]}`} 
        footer={<FooterComponent />}
        style={{ width: '100%' }}>
        {children}
      </Card>
    </div>
  )
}
export default Panel